import { useEffect, useRef } from 'react'

/**
 * Shared behavior for slideout panels:
 * - Locks body scroll on mount, restores on unmount
 * - Focuses the panel element
 * - Closes on Escape key
 *
 * Returns a ref to attach to the panel element.
 */
export function useSlideout(onClose: () => void) {
  const panelRef = useRef<HTMLDivElement>(null)
  const closeRef = useRef(onClose)
  useEffect(() => { closeRef.current = onClose }, [onClose])

  useEffect(() => {
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    panelRef.current?.focus()
    return () => { document.body.style.overflow = prev }
  }, [])

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') closeRef.current()
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [])

  return panelRef
}
